// @mui
import { useContext } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Stack,
  Link,
  Card,
  Button,
  Divider,
  Typography,
  CardHeader,
  CircularProgress,
  IconButton
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { useNavigate } from "react-router-dom";
// utils
import { fToNow } from "../../../utils/formatTime";
// components
import Iconify from "../../../components/Iconify";
import Scrollbar from "../../../components/Scrollbar";
import { MyContext } from "../../../layouts/dashboard";
import validatePhone from "../../../utils/validatePhone";
// ----------------------------------------------------------------------

AppNewsUpdate.propTypes = {
  title: PropTypes.string,
  list: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  to: PropTypes.string
};

export default function AppNewsUpdate({ title, list, loading, to, ...other }) {
  const navigate = useNavigate();
  return (
    <Card {...other}>
      <CardHeader title={title} />

      <Scrollbar>
        <Stack spacing={2} sx={{ p: 3, pr: 0 }}>
          {loading ? (
            <Stack direction="row" justifyContent="center">
              <CircularProgress />
            </Stack>
          ) : (
            <>
              {list.map((enquiries) => (
                <NewsItem key={enquiries.id} enquiries={enquiries} />
              ))}
            </>
          )}
        </Stack>
      </Scrollbar>

      <Divider />

      <Box sx={{ p: 2, textAlign: "right" }}>
        <Button
          size="small"
          onClick={() => navigate(`/dashboard/${to}`)}
          color="inherit"
          endIcon={<Iconify icon={"eva:arrow-ios-forward-fill"} />}
        >
          View all
        </Button>
      </Box>
    </Card>
  );
}

// ----------------------------------------------------------------------

NewsItem.propTypes = {
  enquiries: PropTypes.shape({
    email: PropTypes.string,
    createdAt: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string
  })
};

function NewsItem({ enquiries }) {
  const navigate = useNavigate();
  const { setRow } = useContext(MyContext);
  const { email, name, phone, createdAt } = enquiries;

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Box
        component="img"
        alt={email}
        src={`https://ui-avatars.com/api/?rounded=true&background=random&name=${email}`}
        sx={{ width: 48, height: 48, borderRadius: 1.5, flexShrink: 0 }}
      />

      <Box sx={{ minWidth: 240, flexGrow: 1 }}>
        <Link
          color="inherit"
          variant="subtitle2"
          noWrap
          style={{ cursor: "pointer" }}
          onClick={() => {
            setRow(enquiries);
            navigate("/dashboard/lead-center/details");
          }}
        >
          Enquiry from {name}
        </Link>

        <Stack direction="row" spacing={2}>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              display: "flex",
              alignItems: "center"
            }}
            noWrap
          >
            {email}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              display: "flex",
              alignItems: "center"
            }}
            noWrap
          >
            {validatePhone(phone)}
            <IconButton
              sx={{ ml: 1, p: 1 }}
              onClick={() =>
                window.open(`https://wa.me/${validatePhone(phone)}`, "_blank")
              }
            >
              <WhatsAppIcon />
            </IconButton>
            <Link href={`tel:${validatePhone(phone)}`}>
              <IconButton>
                <LocalPhoneIcon />
              </IconButton>
            </Link>
          </Typography>
        </Stack>
      </Box>

      <Typography
        variant="caption"
        sx={{ pr: 3, flexShrink: 0, color: "text.secondary" }}
      >
        {fToNow(createdAt)}
      </Typography>
    </Stack>
  );
}
